import { Category } from "../types/Category";

export const categoryToLink = (category: Category) => {
  return { name: category.name, path: `/${category.path}` };
};
